export default {
    'packing-lists': 'قوائم التعبئة',
    'the-packing-list': 'قائمة التعبئة',
    'add-a-packing-list': 'إضافة قائمة تعبئة',
    to: 'إلى',
    'packing-list': 'قائمة التعبئة',
}